// src/components/FilterPanel.js
import PillFilter from './PillFilter.js';
import {  useMemo  } from 'react';

const FilterPanel = ({
  movieOptions,         // [{ id, label, image, dimensions: ["2D","3D",…] }, …]
  selectedMovies,       // [ movieId, … ]
  addMovie,
  removeMovie,
  dimensionsOptions,    // [{ id: "2D", label: "2D" }, …]
  selectedDimensions,   // [ dimId, … ]
  addDimension,
  removeDimension,
  }) => {

   // 1) your existing filtered lists
   const filteredDimensions = useMemo(() => {
    if (selectedMovies.length === 0) return dimensionsOptions;
    const dimsInMovies = new Set(
      movieOptions
        .filter(m => selectedMovies.includes(m.id))
        .flatMap(m => m.dimensions || [])
    );
    return dimensionsOptions.filter(d => dimsInMovies.has(d.id));
  }, [selectedMovies, movieOptions, dimensionsOptions]);

  const filteredMovies = useMemo(() => {
    if (selectedDimensions.length === 0) return movieOptions;
    return movieOptions.filter(m =>
      (m.dimensions || []).some(dim => selectedDimensions.includes(dim))
    );
  }, [selectedDimensions, movieOptions]);

  // // — whenever a new dimension is selected, drop any movies that no longer support it —
  // useEffect(() => {
  //   if (!selectedDimensions.length) return;
  //   // build set of movies that *do* support all selected dimensions
  //   const okMovies = new Set(
  //     movieOptions
  //       .filter(m =>
  //         selectedDimensions.every(dim => (m.dimensions || []).includes(dim))
  //       )
  //       .map(m => m.id)
  //   );
  //   // remove any selectedMovie not in okMovies
  //   selectedMovies.forEach(mid => {
  //     if (!okMovies.has(mid)) removeMovie(mid);
  //   });
  // }, [selectedDimensions, movieOptions, selectedMovies, removeMovie]);

  // // — whenever a new movie is selected, drop any dimensions that it doesn’t support —
  // useEffect(() => {
  //   if (!selectedMovies.length) return;
  //   // union of all dimensions supported by selectedMovies
  //   const dimsOk = new Set(
  //     movieOptions
  //       .filter(m => selectedMovies.includes(m.id))
  //       .flatMap(m => m.dimensions || [])
  //   );
  //   // remove any selectedDimension not in dimsOk
  //   selectedDimensions.forEach(did => {
  //     if (!dimsOk.has(did)) removeDimension(did);
  //   });
  // }, [selectedMovies, movieOptions, selectedDimensions, removeDimension]);
  const suggestionsForDimensions = useMemo(() => {
    const selectedDimsObjs = dimensionsOptions.filter(d =>
      selectedDimensions.includes(d.id)
    );
    const rest = filteredDimensions.filter(d =>
      !selectedDimensions.includes(d.id)
    );
    return [...selectedDimsObjs, ...rest];
  }, [dimensionsOptions, filteredDimensions, selectedDimensions]);

  const suggestionsForMovies = useMemo(() => {
    const selectedMovieObjs = movieOptions.filter(m =>
      selectedMovies.includes(m.id)
    );
    const rest = filteredMovies.filter(m =>
      !selectedMovies.includes(m.id)
    );
    return [...selectedMovieObjs, ...rest];
  }, [movieOptions, filteredMovies, selectedMovies]);

    return ( 
    <div
    className="filter-panel">
      <PillFilter
        suggestions={suggestionsForDimensions}
        selected={selectedDimensions}
        onAdd={addDimension}
        onRemove={removeDimension}
        renderPill={(pill) => <span>{pill.label}</span>}
      />
    <PillFilter
        suggestions={suggestionsForMovies}
        selected={selectedMovies}
        onAdd={addMovie}
        onRemove={removeMovie}
        renderPill={(movie) => <span>{movie.label}</span>}
        renderSuggestion={(movie) => {return(<>
        <img
            src={movie.image}
            alt={movie.label}
            style={{ width: "100%", height: 160, objectFit: "cover", borderRadius: 4 }}
          />
        <div style={{ marginTop: 4, fontSize: "0.9rem" }}>{movie.label}</div></>)}}
        isGrid={true}
      />
    </div> 
    );
}
 
export default FilterPanel;